<template>
    <PanelPage>
        <template v-slot:title>
            <SmartBreadcrumbs
                element="InertiaLink"
                :pages="[
                    {
                        name: $tc('messages.tags', 2),
                        href: meta.links.index,
                    },
                    {
                        name: tag.name,
                        href: null,
                    },
                ]"
            />
        </template>
        <form action="" @submit.prevent="submit">
            <Tabs>
                <Tab :title="group.name" :selected="index === 0" v-for="(group, index) in form.groups" :key="group.id">
                    <div class="flex flex-col mt-5">
                        <div class="-my-2 py-2 overflow-x-auto sm:-mx-6 sm:px-6 lg:-mx-8 lg:px-8">
                            <div
                                class="align-middle inline-block min-w-full shadow overflow-hidden sm:rounded-lg border-b border-gray-200"
                            >
                                <table class="min-w-full divide-y divide-gray-200">
                                    <thead>
                                        <tr>
                                            <th
                                                class="w-12 px-2 py-3 bg-gray-50 text-left text-xs leading-4 font-medium text-gray-500 uppercase tracking-wider"
                                            >
                                                &nbsp;
                                            </th>
                                            <th
                                                class="max-w-xs px-6 py-3 bg-gray-50 text-left text-xs leading-4 font-medium text-gray-500 uppercase tracking-wider"
                                            >
                                                {{ $tc('messages.students', 1) }}
                                            </th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr
                                            :class="studentIndex % 2 === 0 ? 'bg-white' : 'bg-gray-50'"
                                            v-for="(student, studentIndex) in group.students"
                                            :key="student.id"
                                        >
                                            <td class="px-1 py-4 whitespace-nowrap text-sm leading-5 text-gray-500">
                                                <input
                                                    v-model="student.has_tag"
                                                    name="grade_levels"
                                                    type="checkbox"
                                                    class="focus:ring-indigo-500 h-4 w-4 text-indigo-600 border-gray-300 rounded"
                                                />
                                            </td>
                                            <td class="px-6 py-4 whitespace-nowrap text-sm leading-5 text-gray-500">
                                                <StudentInfoItem :student="student" />
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                </Tab>
            </Tabs>

            <div class="flex justify-end mt-5">
                <SubmitFormButton :button-text="$t('messages.save')" :processing="form.processing" />
            </div>
        </form>
    </PanelPage>
</template>

<script>
import Layout from '@/Shared/Layout.vue';
import PanelPage from '@/Shared/PanelPage.vue';
import Tabs from '@/components/Tabs.vue';
import Tab from '@/components/Tab.vue';
import StudentInfoItem from '@/components/StudentInfoItem.vue';
import SubmitFormButton from '@/Pages/Teacher/Activities/Subactivities/SubmitFormButton.vue';

export default {
    components: {
        SubmitFormButton,
        StudentInfoItem,
        Tab,
        Tabs,
        PanelPage,
    },
    layout: Layout,
    name: 'Index',
    props: ['meta', 'groups', 'tag'],
    data() {
        return {
            form: this.$inertia.form({
                groups: this.groups,
            }),
        };
    },
    methods: {
        submit() {
            this.form
                .transform((data) => {
                    const students = data.groups
                        .flatMap((g) => g.students)
                        .filter((s) => s.has_tag !== s.original_value)
                        .map((s) => {
                            return {
                                student_file_id: s.student_file_id,
                                has_tag: s.has_tag,
                            };
                        });
                    return {
                        students,
                    };
                })
                .patch(this.meta.links.update);
        },
    },
};
</script>
